module.exports = __webpack_public_path__ + "img/mrpdf.40338d5f.png";